export default __webpack_public_path__ + "01e6cd2e72be7fb457a747c3f4d5b817.png";